import React from 'react';
import {
  Container,
  Paper,
  Typography,
  Button,
  Box,
  Avatar,
  useTheme,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Home as HomeIcon } from '@mui/icons-material';

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          minHeight: '100vh',
          justifyContent: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            maxWidth: 400,
          }}
        >
          <Avatar
            sx={{
              m: 1,
              bgcolor: 'primary.main',
              width: 80,
              height: 80,
              fontSize: '2rem',
            }}
          >
            <Box
              component="img"
              src="/images/SubLime_Mascot.png"
              alt="SubLime Mascot"
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              }}
            />
          </Avatar>
          
          <Typography component="h1" variant="h1" sx={{ mb: 2, textAlign: 'center', fontSize: '4rem', fontWeight: 'bold' }}>
            404
          </Typography>
          
          <Typography component="h2" variant="h4" sx={{ mb: 2, textAlign: 'center' }}>
            Page Not Found
          </Typography>
          
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4, textAlign: 'center' }}>
            Oops! The page you're looking for doesn't exist.
            <br />
            It might have been moved or deleted.
          </Typography>

          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={() => navigate('/dashboard')}
            startIcon={<HomeIcon />}
            sx={{
              mt: 3,
              mb: 2,
              py: 1.5,
              fontSize: '1.1rem',
              color: theme.palette.mode === 'dark' ? 'black' : 'white',
              '&:hover': {
                color: theme.palette.mode === 'dark' ? 'black' : 'white',
              },
            }}
          >
            Go to Dashboard
          </Button>

          <Button
            fullWidth
            variant="outlined"
            size="large"
            onClick={() => navigate(-1)}
            sx={{
              py: 1.5,
              fontSize: '1.1rem',
            }}
          >
            Go Back
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default NotFound; 